import styled from 'styled-components';
import {
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div``;

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 45px;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  margin-bottom: 10px;
  text-align: center;
`;

const Text = styled(TextLayoutComponent)``;

const ContextSegment = styled(SegmentLayoutComponent)`
  &&& {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    margin-top: 40px;
    padding: 20px;
    width: 570px;
  }
`;

const HeaderSegmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
`;

const SegmentTitle = styled(TextLayoutComponent.Bold)``;

const Optional = styled(TextLayoutComponent.Optional)`
  margin: 0 5px;
`;

const PreviewStudyContainer = styled.div`
  margin-left: 10px;
  margin-top: 20px;
`;

const PreviewStudy = styled.a``;

const PreviewStudyIcon = styled(SemanticIcon).attrs(() => ({
  name: 'eye',
}))`
`;

const ContainerDefault = styled.div`
  margin-bottom: 25px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 80px 0;
`;

const SaveButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 125px;
  }
`;

const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-right: 60px;
    width: 125px;
  }
`;

const Title = styled(TextLayoutComponent.Header)``;

const ContainerLoading = styled.div`
  display: flex;
  justify-content: center;
  width: 570px;

`;

const Loader = styled(LoaderLayoutComponent)``;

export {
  Container,
  ContextSegment,
  FormContainer,
  HeaderSegmentContainer,
  Optional,
  PreviewStudy,
  PreviewStudyContainer,
  PreviewStudyIcon,
  SegmentTitle,
  Text,
  ErrorMessage,
  ContainerDefault,
  ButtonContainer,
  CancelButton,
  SaveButton,
  Title,
  ContainerLoading,
  Loader,
};
